export function isPromiseLike(value) {
  return value !== null && typeof value === 'object' && 'then' in value && typeof value.then === 'function';
}